<script setup>
import { defineProps, defineEmits, computed } from "vue";
import { getRangeWeek } from "../../utils/index.js";

const props = defineProps({
  date: {
    type: Date,
    required: true,
  },
});

const emit = defineEmits(["update:date"]);

const range = computed(() => getRangeWeek(props.date));

const changeWeek = (direction) => {
  const newDate = new Date(props.date);
  newDate.setDate(newDate.getDate() + direction * 7);
  emit("update:date", newDate);
};
</script>

<template>
  <div class="flex flex-col md:flex-row justify-between items-center mb-6">
    <h1
      class="text-3xl font-bold text-gray-800 dark:text-gray-100 mb-4 md:mb-0"
    >
      Planificación Semanal
    </h1>
    <div class="flex items-center space-x-4">
      <button
        @click="changeWeek(-1)"
        class="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
        aria-label="Semana anterior"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 text-gray-600 dark:text-gray-300"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>
      <div
        class="text-lg font-medium text-gray-700 dark:text-gray-200 min-w-[150px] text-center"
      >
        Semana del {{ range.start }} al {{ range.end }}
      </div>
      <button
        @click="changeWeek(1)"
        class="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
        aria-label="Semana siguiente"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 text-gray-600 dark:text-gray-300"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>
    </div>
  </div>
</template>
